import React from 'react';
const Overlay = () => {
    return (
        <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, backgroundColor: 'rgba(255, 255, 255, 0.1)' }} />
    );
}

export default Overlay;
//


// WEBPACK FOOTER //
// ./src/components/partials/white_overlay.js